import React from 'react'
import { Container } from '@shared/components/container'
import { CustomFooterOwnProps } from '@shared/components/page-layout/model'

import { FooterContentBlock } from './components/FooterContentBlock'
import { NewLPFooter } from './templates/NewLPFooter'
import { loanPromoFooterItems } from './constants'

import styles from './style.module.scss'

export const ViewNewLoanPromo = (props: CustomFooterOwnProps) => (
	<footer className={styles.wrapper}>
		<Container>
			<NewLPFooter FooterContentBlock={<FooterContentBlock items={loanPromoFooterItems} />} />
		</Container>
	</footer>
)
